import { useState } from "react";
import { useTranslation } from "react-i18next";
import { countries } from "../../../constants/countries-code";
import Input from "../Input/Input";
import { Button } from "antd";
import styles from "./PromoModal.module.scss";
import { Note } from "../../../helbest";
import { useMutation, useQuery } from "@apollo/client";
import { MessagingServices } from "../../../graphql/none_saleor/otp/otp";
import { useDispatch, useSelector } from "react-redux";
import { set_otp_service } from "../../../store/actions/otp_action";
import {
  _login_phone_number,
  _set_channel,
  _set_pending_channel,
  _set_pending_cid,
  _set_pending_cpid,
  set_cid,
  set_cpid,
} from "../../../store/actions/login_actions";
import { BaseChannel } from "../../../base/env";
import { set_carwash_visible } from "../../../store/actions/popup_actions";
import { showAllErrors } from "../../../base/utils";
import { SendOTPMutation } from "../../../graphql/none_saleor/auth/auth";
import { useSearchParams } from "react-router-dom";

const LoginPromo = ({ setStep, setAvailableOtp, setIsVisible }) => {
  const { i18n, t } = useTranslation();
  const [countryCode, setCountryCode] = useState(countries[0].code);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const { otpService } = useSelector((state) => state.Otp);
  const {
    cid,
    cpid,
    urlCode,
    pendingChannel,
    pendingCid,
    pendingCpid,
    channel,
  } = useSelector((state) => state.Login);

  const countryCodeSelected = countries.find((i) => i.code === countryCode);

  const effectiveCid = pendingCid || cid;
  const effectiveCpid = pendingCpid || cpid;

  const { refetch } = useQuery(MessagingServices, {
    context: {
      clientName: "otp",
    },
    onError: (error) => {
      Note.error(error.message);
    },
    skip: true,
  });

  const [sendOtpMutation] = useMutation(SendOTPMutation, {
    context: {
      // headers: {
      //   "site-url": "garajmall.com",
      // },
      clientName: "auth",
    },
  });

  const [searchParams] = useSearchParams();

  const platform = searchParams.get("platform");

  const login = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const { phoneNumber } = Object.fromEntries(formData.entries());

    if (!phoneNumber || phoneNumber.length < countryCodeSelected.length) {
      return Note.error(t("login.messages.mobile_invalid"));
    }
    if (!countryCode) {
      return Note.error(t("login.messages.country_code_invalid"));
    }
    setLoading(true);
    refetch().then((availableResponse) => {
      if (!availableResponse.data) return;
      let messagingService = "";
      if (!otpService) {
        const services = availableResponse.data.messagingServices;
        setAvailableOtp(services);
        messagingService =
          services.find((service) => service.isDefault)?.value ||
          services[0].value;
        dispatch(set_otp_service(messagingService));
      } else {
        messagingService = otpService;
      }
      sendOtpMutation({
        variables: {
          phoneNumber,
          countryCode,
          messagingService,
          cid: effectiveCid || null,
          cpid: effectiveCpid,
          urlCode: urlCode || null,
          platform,
          channelSlug: pendingChannel || BaseChannel,
        },
        onCompleted: (response) => {
          if (!response.sendOtp.errors.length) {
            dispatch(
              _login_phone_number({
                phone_number: phoneNumber,
                country_code: countryCode,
              }),
            );

            setStep("otp");
          } else {
            showAllErrors(response.sendOtp.errors);
            const hasCidError = response.sendOtp.errors.some(
              (err) => err.field === "cid",
            );
            if (hasCidError) {
              localStorage.removeItem("cid");
              localStorage.removeItem("cpid");
              localStorage.removeItem("channel");
              dispatch(set_cid(""));
              dispatch(set_cpid("gmall"));
              dispatch(_set_channel(BaseChannel, channel));
              dispatch(_set_pending_channel(""));
              dispatch(_set_pending_cpid(""));
              dispatch(_set_pending_cid(""));
              dispatch(set_carwash_visible(false));
              setIsVisible?.(false);
            }
          }
        },
      }).then(() => setLoading(false));
    });
  };

  return (
    <form onSubmit={login} className={styles.form}>
      <div
        className={styles["phone-number-wrapper"]}
        style={{
          flexDirection: i18n.dir() === "ltr" ? "row" : "row-reverse",
        }}
      >
        <div className={styles["country-code-wrapper"]}>
          <countryCodeSelected.icon className={styles.CountryIcon} />
          <select
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
          >
            {countries.map((countryItem) => {
              return (
                <option
                  key={countryItem.code}
                  value={countryItem.code}
                  className={styles.SelectCountryOption}
                >
                  {countryItem.label}
                </option>
              );
            })}
          </select>
        </div>
        <Input
          name="phoneNumber"
          maxLength={countryCodeSelected.length}
          placeholder={t("common.phone")}
          pattern="[0-9]*"
          inputMode="numeric"
          //   helperText={t('login.mobileNumberHelper')}
        />
      </div>
      <Button
        size="large"
        type="primary"
        htmlType="submit"
        loading={loading}
        style={{
          width: "100%",
        }}
      >
        {t("gmall.button")}
      </Button>
    </form>
  );
};

export default LoginPromo;
